import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, MessageCircle, MapPin } from "lucide-react";
import { SITE, SERVICES } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-forest-deep text-cream pt-24 pb-10 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="absolute inset-x-0 top-0 pv-rule opacity-70" />
      <div className="mx-auto max-w-[1400px] grid grid-cols-1 md:grid-cols-12 gap-14 md:gap-10">
        {/* Brand */}
        <div className="md:col-span-4">
          <Link to="/" className="inline-block mb-6">
            <img
              src={SITE.logoUrl}
              alt="Diamond Life Bursa Logo"
              className="logo-tone h-20 w-auto select-none"
              draggable={false}
            />
          </Link>
          <p className="text-sm text-cream/65 font-light leading-relaxed max-w-sm">
            Bursa'nın premium spa ve masaj merkezi. Sertifikalı terapistler, organik yağlar ve butik atmosferde imzalı ritüeller.
          </p>
          <div className="flex items-center gap-3 mt-7">
            <a
              href={SITE.socials.instagram}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              data-testid="footer-social-instagram"
              className="inline-flex items-center gap-2.5 border border-cream/20 hover:border-bronze-soft hover:text-bronze-soft px-4 h-10 transition-colors duration-300 rounded-full text-sm text-cream/80"
            >
              <Instagram className="w-4 h-4" />
              <span>@masajsalonu_bursa</span>
            </a>
          </div>
        </div>

        {/* Hizmetler */}
        <div className="md:col-span-3">
          <div className="text-[11px] tracking-luxury uppercase text-bronze-soft mb-5">Hizmetler</div>
          <ul className="space-y-3">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/hizmetler/${s.slug}`}
                  data-testid={`footer-service-${s.slug}`}
                  className="text-sm text-cream/75 hover:text-cream transition-colors duration-300"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Links */}
        <div className="md:col-span-2">
          <div className="text-[11px] tracking-luxury uppercase text-bronze-soft mb-5">Bağlantılar</div>
          <ul className="space-y-3 text-sm text-cream/75">
            <li><Link to="/hakkimizda" className="hover:text-cream">Hakkımızda</Link></li>
            <li><Link to="/galeri" className="hover:text-cream">Galeri</Link></li>
            <li><Link to="/hediye-ceki" data-testid="footer-gift-link" className="hover:text-cream">Hediye Çeki</Link></li>
            <li><Link to="/iletisim" className="hover:text-cream">İletişim</Link></li>
            <li><Link to="/admin/login" className="hover:text-cream opacity-50">Admin</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="md:col-span-3">
          <div className="text-[11px] tracking-luxury uppercase text-bronze-soft mb-5">İletişim</div>
          <ul className="space-y-3 text-sm text-cream/80">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 text-bronze-soft mt-0.5" />
              <a href={`tel:${SITE.phoneRaw}`} className="hover:text-cream">{SITE.phoneDisplay}</a>
            </li>
            <li className="flex items-start gap-3">
              <MessageCircle className="w-4 h-4 text-bronze-soft mt-0.5" />
              <a href={`https://wa.me/${SITE.whatsappRaw}`} target="_blank" rel="noreferrer" className="hover:text-cream">WhatsApp ile yazın</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-bronze-soft mt-0.5" />
              <a href={SITE.mapsShare} target="_blank" rel="noreferrer" className="hover:text-cream">{SITE.address}</a>
            </li>
          </ul>
          <div className="mt-6 text-[11px] tracking-luxury uppercase text-bronze-soft mb-3">Çalışma Saatleri</div>
          <ul className="space-y-1.5 text-sm text-cream/65">
            {SITE.hours.map((h) => (
              <li key={h.label} className="flex justify-between gap-4">
                <span>{h.label}</span>
                <span className="text-cream">{h.value}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] mt-16 pt-6 border-t border-cream/10 flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] text-cream/50 tracking-wide">
        <span>© {new Date().getFullYear()} Diamond Life Bursa Masaj Salonu — Tüm hakları saklıdır.</span>
        <a
          href={`https://wa.me/${SITE.agency.whatsappRaw}?text=${encodeURIComponent("Merhaba, Diamond Life Masaj Bursa web sitesi üzerinden ulaşıyorum.")}`}
          target="_blank"
          rel="noreferrer"
          data-testid="footer-agency-credit"
          className="group inline-flex items-center gap-2 hover:text-cream transition-colors duration-300"
        >
          <span>Web Sitesi ve Dijital Çözümler</span>
          <span className="pv-italic bronze-text text-[13px] group-hover:scale-105 transition-transform">Bana Bi Media</span>
          <span className="text-cream/40">· İstanbul</span>
        </a>
      </div>
    </footer>
  );
}
